import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Percepere din metoda de plată',
    [BillingMode.InternalInvoicing]: 'Percepere din vânzări',
    active: 'Activ',
    on_trial: 'În probă',
    launch_pending: 'În așteptare până la data lansării',
    billing_disabled: 'Facturare dezactivată',
    on_grace_period: 'În perioadă de grație',
    past_due: 'Restanță',
    cancelled: 'Anulat',
  },
};
